function capitalizeFirstLetter(str: string): string {
  if (!str || str.length === 0) return str; // Handle empty string or invalid input
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default capitalizeFirstLetter;
